export default {
  selectedStatus: [],
  selectedYear: '',
  selectedSeason: [],
  selectedVariety: '',
  selectedGrade: '',
  word: '',
  currentPage: 1,
  orderName: '',
  sort: '',
  modalOrderName: 'field_name',
  modalSort: 'asc'
}
